(function () {
  function fmtMoney(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  function resizeCdnImg(src, size) {
    if (!src) return src;
    var sep = src.indexOf("?") > -1 ? "&" : "?";
    return src + sep + "width=" + size;
  }

  /* ---------- drawers ---------- */
  var backdrop = document.getElementById("backdrop");
  var menuDrawer = document.getElementById("menu-drawer");
  var cartDrawer = document.getElementById("cart-drawer");

  function closeDrawers() {
    menuDrawer.classList.remove("open");
    cartDrawer.classList.remove("open");
    backdrop.classList.remove("show");
  }
  function openMenu() {
    closeDrawers();
    menuDrawer.classList.add("open");
    backdrop.classList.add("show");
  }
  function openCart() {
    closeDrawers();
    cartDrawer.classList.add("open");
    backdrop.classList.add("show");
    fetchCart();
  }

  var menuOpenBtn = document.getElementById("menu-open");
  var menuCloseBtn = document.getElementById("menu-close");
  var cartOpenBtn = document.getElementById("cart-open");
  var cartCloseBtn = document.getElementById("cart-close");
  if (menuOpenBtn) menuOpenBtn.addEventListener("click", openMenu);
  if (menuCloseBtn) menuCloseBtn.addEventListener("click", closeDrawers);
  if (cartOpenBtn) cartOpenBtn.addEventListener("click", function (e) { e.preventDefault(); openCart(); });
  if (cartCloseBtn) cartCloseBtn.addEventListener("click", closeDrawers);
  backdrop.addEventListener("click", closeDrawers);

  /* ---------- mega menu ---------- */
  function closeMegaMenus() {
    document.querySelectorAll(".mega-panel").forEach(function (p) { p.classList.remove("open"); });
    document.querySelectorAll(".mega-toggle").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
  }
  document.querySelectorAll(".mega-trigger").forEach(function (trigger) {
    var btn = trigger.querySelector(".mega-toggle");
    var panel = trigger.querySelector(".mega-panel");
    if (!btn || !panel) return;
    trigger.addEventListener("mouseenter", function () {
      closeMegaMenus();
      panel.classList.add("open");
      btn.setAttribute("aria-expanded", "true");
    });
    trigger.addEventListener("mouseleave", function () {
      panel.classList.remove("open");
      btn.setAttribute("aria-expanded", "false");
    });
    btn.addEventListener("focus", function () {
      closeMegaMenus();
      panel.classList.add("open");
      btn.setAttribute("aria-expanded", "true");
    });
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      var isOpen = panel.classList.contains("open");
      closeMegaMenus();
      if (!isOpen) {
        panel.classList.add("open");
        btn.setAttribute("aria-expanded", "true");
      }
    });
  });
  document.addEventListener("focusin", function (e) {
    if (!e.target.closest(".mega-trigger")) closeMegaMenus();
  });
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".mega-trigger")) closeMegaMenus();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeDrawers(); closeMegaMenus(); }
  });

  /* ---------- mobile menu accordion ---------- */
  document.querySelectorAll(".menu-expand-toggle").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var open = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", open ? "false" : "true");
      document.getElementById("submenu-" + btn.getAttribute("data-expand")).classList.toggle("open", !open);
    });
  });


  /* ---------- quantity steppers (non-cart, e.g. PDP) ---------- */
  document.querySelectorAll(".qty-add-row .qty-stepper").forEach(function (stepper) {
    var input = stepper.querySelector("input");
    stepper.querySelectorAll("button[data-qty]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var delta = parseInt(btn.getAttribute("data-qty"), 10);
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
      });
    });
  });

  /* ---------- accordions ---------- */
  document.querySelectorAll(".accordion-item > button").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var item = btn.parentElement;
      var isOpen = item.getAttribute("data-open") === "true";
      if (isOpen) {
        item.removeAttribute("data-open");
      } else {
        item.setAttribute("data-open", "true");
      }
    });
  });

  /* ---------- real Shopify cart ---------- */
  function cartLineHTML(item) {
    var img = item.image
      ? '<img class="card-photo" style="width:76px;height:96px;object-fit:cover;" src="' + resizeCdnImg(item.image, 200) + '" alt="">'
      : '<div class="ph" style="width:76px;height:96px;"><div class="cross-a"></div><div class="cross-b"></div></div>';
    var variant = item.variant_title && item.variant_title !== "Default Title"
      ? '<div class="cart-line-meta">' + item.variant_title + "</div>"
      : "";
    return (
      '<div class="cart-line" data-key="' + item.key + '">' +
        img +
        '<div class="cart-line-info">' +
          "<h4>" + item.product_title + "</h4>" +
          variant +
          '<div class="qty-stepper">' +
            '<button type="button" data-cart-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
            '<input type="number" value="' + item.quantity + '" min="0" data-cart-qty-input>' +
            '<button type="button" data-cart-qty="1" aria-label="Increase quantity">+</button>' +
          "</div>" +
        "</div>" +
        '<div class="cart-line-side">' +
          '<button type="button" class="cart-line-remove-icon" data-cart-remove aria-label="Remove item">' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4 7h16M9 7V4h6v3M6 7l1 13a2 2 0 002 2h6a2 2 0 002-2l1-13M10 11v6M14 11v6"/></svg>' +
          "</button>" +
          '<div class="cart-line-price">' + fmtMoney(item.final_line_price) + "</div>" +
        "</div>" +
      "</div>"
    );
  }

  function renderCartDrawer(cart) {
    var body = document.getElementById("cart-drawer-body");
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="drawer-empty">Your cart is empty.</div>';
    } else {
      body.innerHTML = cart.items.map(cartLineHTML).join("");
    }
    var drawerCount = document.getElementById("drawer-count");
    var drawerTotal = document.getElementById("drawer-total");
    var headerCount = document.getElementById("header-cart-count");
    if (drawerCount) drawerCount.textContent = cart.item_count;
    if (drawerTotal) drawerTotal.textContent = fmtMoney(cart.total_price);
    if (headerCount) headerCount.textContent = cart.item_count;
  }

  function fetchCart() {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(renderCartDrawer);
  }

  function changeLine(key, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(renderCartDrawer);
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-cart-qty]");
    if (!btn) return;
    var line = btn.closest(".cart-line");
    var input = line.querySelector("[data-cart-qty-input]");
    var val = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute("data-cart-qty"), 10));
    input.value = val;
    changeLine(line.getAttribute("data-key"), val);
  });

  document.addEventListener("change", function (e) {
    if (!e.target.matches("[data-cart-qty-input]")) return;
    var line = e.target.closest(".cart-line");
    changeLine(line.getAttribute("data-key"), Math.max(0, parseInt(e.target.value, 10) || 0));
  });

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-cart-remove]");
    if (!btn) return;
    var line = btn.closest(".cart-line");
    changeLine(line.getAttribute("data-key"), 0);
  });

  /* Hijack any add-to-cart form (quick-add on cards, PDP form) to use AJAX + open drawer */
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form.matches('form[action$="/cart/add"]')) return;
    e.preventDefault();
    var formData = new FormData(form);
    fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData,
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        openCart();
      })
      .catch(function () {
        form.submit();
      });
  });

  /* keep header cart count in sync on load */
  fetchCart();
})();

/* ---------- PDP description: cap to 2 images ---------- */
(function () {
  var desc = document.querySelector(".pdp-description");
  if (!desc) return;
  var imgs = Array.prototype.slice.call(desc.querySelectorAll("img"));
  imgs.forEach(function (img, i) {
    if (i < 2) return;
    var wrapper = img.parentElement;
    if (wrapper && wrapper !== desc && wrapper.children.length === 1 && wrapper.textContent.trim() === "") {
      wrapper.style.display = "none";
    } else {
      img.style.display = "none";
    }
  });
})();

/* ---------- PDP swipeable gallery ---------- */
(function () {
  var main = document.getElementById("gallery-main");
  if (!main) return;
  var slides = Array.prototype.slice.call(main.querySelectorAll(".gallery-slide"));
  var thumbs = Array.prototype.slice.call(document.querySelectorAll(".thumb-photo"));
  if (!slides.length) return;

  function setActiveThumb(imageId) {
    thumbs.forEach(function (t) {
      t.classList.toggle("active", t.getAttribute("data-image-id") === imageId);
    });
  }

  function goToImageId(imageId, smooth) {
    var slide = slides.filter(function (s) { return s.getAttribute("data-image-id") === imageId; })[0];
    if (!slide) return;
    main.scrollTo({ left: slide.offsetLeft, behavior: smooth ? "smooth" : "auto" });
    setActiveThumb(imageId);
  }

  thumbs.forEach(function (t) {
    t.addEventListener("click", function () {
      goToImageId(t.getAttribute("data-image-id"), true);
    });
  });

  var scrollTimeout;
  main.addEventListener("scroll", function () {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function () {
      var best = null, bestDist = Infinity;
      slides.forEach(function (s) {
        var dist = Math.abs(s.offsetLeft - main.scrollLeft);
        if (dist < bestDist) { bestDist = dist; best = s; }
      });
      if (best) setActiveThumb(best.getAttribute("data-image-id"));
    }, 100);
  });

  window.clarasGoToGalleryImageId = function (imageId) { goToImageId(String(imageId), true); };
})();

/* ---------- PDP variant picker ---------- */
(function () {
  var form = document.getElementById("pdp-form");
  if (!form) return;

  var variantsEl = document.getElementById("pdp-variants-json");
  var variants = JSON.parse(variantsEl.textContent);

  var optionBlocks = Array.prototype.slice.call(form.querySelectorAll(".option-block"));
  var selection = optionBlocks.map(function (block) {
    var activeBtn = block.querySelector(".swatch.active, .size-btn.active");
    return activeBtn ? activeBtn.getAttribute("data-value") : null;
  });

  function findVariant() {
    return variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      return selection.every(function (val, i) { return val == null || opts[i] === val; });
    });
  }

  function fmtMoney(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  function updateUI(swapImage) {
    var variant = findVariant();
    var addBtn = document.getElementById("pdp-add-btn");
    var variantInput = document.getElementById("pdp-variant-id");
    var priceEl = document.getElementById("pdp-price");
    var compareEl = document.getElementById("pdp-compare");
    var saveEl = document.getElementById("pdp-save");

    if (!variant) {
      addBtn.disabled = true;
      addBtn.style.opacity = ".5";
      addBtn.style.cursor = "not-allowed";
      addBtn.textContent = "Unavailable";
      return;
    }

    variantInput.value = variant.id;

    priceEl.textContent = fmtMoney(variant.price);
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      compareEl.style.display = "";
      saveEl.style.display = "";
      compareEl.textContent = fmtMoney(variant.compare_at_price);
      saveEl.textContent = "Save " + fmtMoney(variant.compare_at_price - variant.price);
      priceEl.classList.add("sale");
    } else {
      compareEl.style.display = "none";
      saveEl.style.display = "none";
      priceEl.classList.remove("sale");
    }

    if (variant.available) {
      addBtn.disabled = false;
      addBtn.style.opacity = "";
      addBtn.style.cursor = "";
      addBtn.textContent = "Add to Cart";
    } else {
      addBtn.disabled = true;
      addBtn.style.opacity = ".5";
      addBtn.style.cursor = "not-allowed";
      addBtn.textContent = "Sold Out";
    }


    if (swapImage && variant.featured_image && variant.featured_image.id && window.clarasGoToGalleryImageId) {
      window.clarasGoToGalleryImageId(variant.featured_image.id);
    }
  }

  optionBlocks.forEach(function (block, idx) {
    var label = block.querySelector("[data-option-value-label]");
    block.querySelectorAll(".swatch, .size-btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        block.querySelectorAll(".swatch, .size-btn").forEach(function (b) { b.classList.remove("active"); });
        btn.classList.add("active");
        selection[idx] = btn.getAttribute("data-value");
        if (label) label.textContent = (selection[idx] || "").replace(/\s*\(.*?\)\s*$/, "");
        updateUI(true);
      });
    });
  });

  updateUI(false);
})();
